module.exports = __webpack_public_path__ + "static/media/createRecipeBackground0.ddbae42d.jpg";